var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-footer": "",
          "disable-pagination": "",
          "mobile-breakpoint": "0",
          groupBy: "position",
          dense: "",
          expanded: [],
          height:
            null /*`calc(100vh - ${$vuetify.breakpoint.smAndDown ? 317 : 257}px)`*/,
        },
        scopedSlots: _vm._u(
          [
            {
              key: `header`,
              fn: function ({ props }) {
                return [
                  props.headers.find((e) => e.label)
                    ? _c(
                        "thead",
                        {
                          staticStyle: {
                            "border-bottom": "hidden",
                            "box-shadow": "0px 1px rgba(0, 0, 0, 0.12)",
                          },
                        },
                        [
                          _c(
                            "tr",
                            { class: { "sticky-header": false } },
                            _vm._l(
                              props.headers.filter((e) => e.colspan),
                              function (header, idx) {
                                return _c(
                                  "th",
                                  {
                                    key: idx,
                                    attrs: { colspan: header.colspan },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "font-weight-black",
                                        class: header.class,
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(header.label) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
            },
            {
              key: `group.header`,
              fn: function ({ group, items }) {
                return _vm._l(_vm.columnOrder, function (key) {
                  return _c(
                    "td",
                    {
                      key: key,
                      staticClass: "soli-blue white--text font-weight-black",
                    },
                    [
                      key == "name"
                        ? _c("div", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.categoryOrder[group]) +
                                "\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      items.find((e) => e.headerSummary)
                        ? _c(
                            "div",
                            {
                              attrs: {
                                set: (_vm.headerSummary = items.find(
                                  (e) => e.headerSummary
                                )),
                              },
                            },
                            [
                              key !== "difference" && key !== "name"
                                ? _c("div", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.headerSummary[key]) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              key == "difference"
                                ? _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.headerSummary[key].color,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.headerSummary[key].icon)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                })
              },
            },
            {
              key: `group.summary`,
              fn: function ({ items }) {
                return [
                  items.find((e) => e.summary)
                    ? _vm._l(_vm.columnOrder, function (key) {
                        return _c(
                          "td",
                          {
                            key: key,
                            staticClass: "font-weight-bold px-4 white",
                          },
                          [
                            key !== "difference"
                              ? _c("div", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        items.find((e) => e.summary)[key]
                                      ) +
                                      "\n                    "
                                  ),
                                ])
                              : _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: items.find((e) => e.summary)[key]
                                        .color,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        items.find((e) => e.summary)[key].icon
                                      )
                                    ),
                                  ]
                                ),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ]
              },
            },
            {
              key: `item`,
              fn: function ({ item }) {
                return [
                  !item.summary && !item.headerSummary
                    ? _c(
                        "tr",
                        _vm._l(_vm.columnOrder, function (key) {
                          return _c(
                            "td",
                            { key: key },
                            [
                              key !== "difference"
                                ? _c(
                                    "div",
                                    [
                                      !item.userEntry ||
                                      key !== "format" ||
                                      !_vm.userEntry
                                        ? _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(item[key]) +
                                                  "\n                            "
                                              ),
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    top: "",
                                                    maxWidth: "300",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            item[
                                                              "description"
                                                            ] && key == "format"
                                                              ? _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          right:
                                                                            "",
                                                                          color:
                                                                            "accent",
                                                                        },
                                                                      },
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "help"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            item[
                                                              "percent_description"
                                                            ] &&
                                                            key == "percent"
                                                              ? _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          right:
                                                                            "",
                                                                          color:
                                                                            "accent",
                                                                        },
                                                                      },
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      "help"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item["description"] ||
                                                        item[
                                                          "percent_description"
                                                        ]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c("v-currency-field", {
                                            ref: "currencyField",
                                            refInFor: true,
                                            staticClass: "pb-2",
                                            staticStyle: {
                                              width: "78px",
                                              "font-size": "0.875rem",
                                            },
                                            attrs: {
                                              dense: "",
                                              flat: "",
                                              prefix: "$",
                                              "hide-details": "",
                                              max: 99999,
                                            },
                                            model: {
                                              value: _vm.form[item.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  item.key,
                                                  $$v
                                                )
                                              },
                                              expression: "form[item.key]",
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              key == "difference"
                                ? _c(
                                    "v-icon",
                                    {
                                      attrs: { color: item.difference?.color },
                                    },
                                    [_vm._v(_vm._s(item.difference?.icon))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }